import colonyAPI from '@/api/colony';

import state from './state';
import * as types from './mutation-types';

export default {
  getStationActivity({ commit }) {
    commit(types.GET_STATION_ACTIVITY);
    const params = {
      params: {
        region: state.region,
        offset: state.offset,
        startDate: state.startDate.format(),
        endDate: state.endDate.format(),
      },
    };

    return colonyAPI
      .get('station-activity/', params)
      .then(response => commit(types.GET_STATION_ACTIVITY_SUCCESS, response))
      .catch(error => commit(types.GET_STATION_ACTIVITY_FAILURE, error.error));
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/stationactivity/actions.js